import React, { useContext, useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box, TextField } from "@mui/material";
import { getMail, SendToDepartment, SendToUsername } from "../../../../api/request/dashboard/dashboard";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ThemeContext } from "../../../../context/ThemeContext";
import { getCookies } from "../../../../services/Cookies";
import { useTranslation } from "react-i18next";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { updateEmail } from '../../../../store/Slices/emailsSlice';

export default function ViewMail({ open, handleClose, mail, onUpdateEmails }) {
    const [content, setContent] = useState("");
    const [replyOpen, setReplyOpen] = useState(false);
    const [replyContent, setReplyContent] = useState("");
    const [recipient, setRecipient] = useState("");
    const [subject, setSubject] = useState("");
    const { darkMode } = useContext(ThemeContext)
    const clientID = getCookies("clientId");
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const { departments = [] } = useSelector(state => state.email, shallowEqual);


    useEffect(() => {
        if (mail?.id) {
            getMail(mail.id)
                .then((response) => {
                    setContent(response.data);

                    if (mail.unread) {
                        dispatch(updateEmail({ ...mail, unread: false }));
                    }
                })
                .catch((error) => {
                    console.error("Error fetching mail:", error);
                    toast.error("Failed to load mail.");
                });
        }
    }, [mail, clientID, dispatch]);


    const handleReply = () => {
        setRecipient(mail?.senderUsername || "Unknown");
        setSubject(`Re: ${mail?.subject || "No Subject"}`);
        setReplyContent("");
        setReplyOpen(true);
    };

    const handleSendReply = async () => {
        if (!recipient || !replyContent.trim()) {
            toast.error("Recipient and message cannot be empty.");
            return;
        }

        const replyData = {
            recipient,
            subject,
            content: replyContent
        };

        const isDepartment = departments.some((department) => department.name === mail?.senderName);

        try {
            let response;
            if (isDepartment) {
                // Send reply to department
                response = await SendToDepartment(replyData);
            } else {
                // Send reply to username
                response = await SendToUsername({
                    content: replyContent,
                    subject,
                    toUserType: mail?.senderType,
                    toUsername: recipient,
                });
            }

            console.log("Response from sending mail:", response);
            if (response.status === 200) {
                toast.success("Mail sent successfully!", {
                    duration: 2000,
                    position: "top-right",
                });

                setTimeout(() => {
                    handleClose();
                }, 1500);
            }
        } catch (error) {
            console.error("Error sending reply:", error);
            toast.error("Failed to send reply.");
        }
    };


    const handleChange = (value) => {
        setReplyContent(value);
        console.log("Content updated:", value);
    };

    const quillModules = {
        toolbar: [
            [{ size: [] }], ["bold", "italic", "underline", "strike"], [{ list: "ordered" }, { list: "bullet" }],
            ["blockquote", "code-block"], ["link", "image"], [{ align: [] }], ["clean"],
        ],
    };

    const quillFormats = ["font", "size", "bold", "italic", "underline", "strike", "list", "bullet", "blockquote", "code-block", "link", "image", "align",];

    const handleReplyClose = () => {
        handleClose()
        if (onUpdateEmails) {
            onUpdateEmails();
        }
        setReplyOpen(false);
    }
    return (
        <>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                <Box>
                    <DialogTitle sx={{ backgroundColor: "#1976D2", color: "white", p: 1 }}>
                        <Typography variant="body1" align="center">{t('viewMail')}</Typography>
                    </DialogTitle>
                    <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", minHeight: "200px", padding: 2, height: '400px' }}>
                        {!replyOpen ? (
                            <>
                                <TextField label={t('from')} value={mail?.senderUsername || "Unknown"} fullWidth variant="outlined" InputProps={{ readOnly: true }} sx={{ marginBottom: 2, mt: 2 }} />
                                <TextField label={t('subject')} value={mail?.subject || "Unknown"} fullWidth variant="outlined" InputProps={{ readOnly: true }} sx={{ marginBottom: 2 }} />
                                <ReactQuill value={content || "Loading..."} readOnly={true} theme="bubble" style={{ height: "400px", marginBottom: "2px", color: darkMode ? "#fff" : "#000", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }} />
                            </>
                        ) : (
                            <>
                                <TextField label={t('To')} value={recipient} fullWidth variant="outlined" InputProps={{ readOnly: true }} sx={{ marginBottom: 2, mt: 2 }} />
                                <TextField label={t('subject')} value={subject} fullWidth variant="outlined" InputProps={{ readOnly: true }} sx={{ marginBottom: 2 }} />
                                <ReactQuill key={replyOpen ? "reply-mode" : "view-mode"} value={replyContent} onChange={handleChange} theme="snow" placeholder={t('writeyourmessage')} modules={quillModules} formats={quillFormats} style={{ height: "200px", marginBottom: "2px", color: darkMode ? "#fff" : "#000", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }} />

                            </>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ padding: "16px", backgroundColor: darkMode ? "#151924" : "#f5f5f5" }}>
                        {replyOpen ? (
                            <>
                                <Button onClick={handleSendReply} variant="contained" color="primary">{t('send')}</Button>
                                <Button onClick={handleReplyClose} variant="outlined" color="primary">{t('cancel')}</Button>
                            </>
                        ) : (
                            <>
                                <Button onClick={handleReply} variant="contained" color="primary">{t('reply')}</Button>
                                <Button onClick={handleClose} variant="outlined" color="primary">{t('close')}</Button>
                            </>
                        )}
                    </DialogActions>
                </Box>
            </Dialog>



        </>
    );
}
